import { Grid } from "@material-ui/core";
import { costPerMileWidgetStyle } from "./style";
import WidgetTitle from "../WidgetTitle/WidgetTitle";
import ExportButton from "components/ExportButton/ExportButton";
import { IconDownloadFile, IconTruck } from "icons";
import { Bar, BarChart, Cell, LabelList, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import EmptyPlaceholder from "components/EmptyPlaceholder/EmptyPlaceholder";
import _ from "lodash";
import { loadDistanceList } from "../loadsDashboardConsts";
import { useGetInvoicesQuery } from "features/invoice/loads/loadInvoiceSlice";
import { arrayToObject } from "utils/object-util";
import LoadsListDialog from "../LoadsListDialog";
import { useState } from "react";

const CostPerMileWidget = ({ loads, status, loading }) => {
    const classes = costPerMileWidgetStyle();
    let { data: invoices, error, isFetching } = useGetInvoicesQuery(null);
    invoices = invoices || [];

    const [selectedBar, setSelectedBar] = useState(null);
    const [openDialog, setOpenDialog] = useState(false);

    const invoicesLookup = arrayToObject(invoices, 'loadId');

    let loadsWithInvoices = loads.map(l => ({
        ...l,
        invoice: invoicesLookup?.[l.id],
    }));

    let groupedData = _.groupBy(loadsWithInvoices, "loadDistance");
    let finalData = loadDistanceList.map((ld) => {
        const loads = groupedData[ld.id]?.filter(l => !!l?.invoice);
        const costAverage = loads?.length ? +_.meanBy(loads, (l) => l?.invoice?.finalAmount / l?.miles ?? 0)?.toFixed(1) : 0;
        return {
            ...ld,
            loads,
            costAverage,
            costAverageText: `$${costAverage ?? 0}`
        };
    });

    const CustomTooltip = ({ payload }) => {
        return (
            <div className={classes.graphTootltip}>
                <p>
                    <div style={{ fontSize: 11 }}>Cost Per Mile</div>
                    <div style={{ fontSize: 10 }}><b>{payload?.[0]?.payload?.name}</b></div>
                    <div style={{ color: '#33A6FE' }}><b>{payload?.[0]?.payload?.costAverageText}</b></div>
                </p>
            </div>
        );
    };

    const mapExportData = (a => {
        return {
            ['Load Distance']: `${a.name}`,
            ['Cost Per Mile Average']: `${a.costAverageText}`
        };
    })

    const onClickBar = (data) => {
        setSelectedBar(data);
        setOpenDialog(true);
    }

    const CustomTitle = () => {
        return <div className={classes.dialogTitleWrapper}>
            <div className={classes.dialogTitle}>
                <IconTruck />
                Loads with {selectedBar?.name} Miles Distance ({selectedBar?.loads?.length})
            </div>
        </div>
    }

    return <Grid container direction="column" className={classes.graphWrapper}>
        <Grid item>
            <WidgetTitle
                title='Cost Per Mile'
                loading={loading || isFetching}
            />
        </Grid>
        <Grid item style={{ height: 340, position: 'relative' }}>
            <div style={{ position: 'absolute', top: '-1.5em', right: '0.5em' }}>
                <ExportButton
                    btnStyle='text'
                    label=""
                    icon={<IconDownloadFile />}
                    fileLabel="Export"
                    data={finalData}
                    mapExportData={mapExportData}
                />
            </div>
            {!!finalData?.length ?
                <ResponsiveContainer width="100%" height="100%">
                    <BarChart
                        data={finalData}
                        margin={{ top: 50, right: 20, bottom: 10 }}
                    >
                        <XAxis
                            type="category"
                            axisLine={false}
                            interval={~~(finalData?.length / 40)}
                            dataKey="name"
                            tickLine={false}
                            tick={{
                                fontSize: '0.75em',
                                fill: '#787777',
                                fontWeight: 'bold'
                            }}
                        />
                        <YAxis
                            type="number"
                            dataKey="costAverage"
                            axisLine={false}
                            tickLine={false}
                            tick={{
                                fontSize: '0.75em',
                                fill: '#787777',
                            }}
                            tickFormatter={(value) => `$${value}`}
                        />
                        <Tooltip
                            content={<CustomTooltip />}
                            cursor={{ fill: '#F3F5F6' }}
                        />
                        <Bar
                            dataKey="costAverage"
                            maxBarSize={6}
                            onClick={(data) => onClickBar(data)}
                            cursor='pointer'
                        >
                            {finalData.map((entry, index) => (
                                <Cell key={`cell-${index}`} fill='#33A6FE' />
                            ))}
                            <LabelList dataKey="costAverageText" position="top" style={{ fontSize: 10, fill: '#787777' }} />
                        </Bar>
                    </BarChart>
                </ResponsiveContainer>
                : <EmptyPlaceholder text='No Loads' />}
            <LoadsListDialog
                loads={selectedBar?.loads}
                openDialog={openDialog}
                setOpenDialog={setOpenDialog}
                title={<CustomTitle />}
            />
        </Grid>
    </Grid >
}
export default CostPerMileWidget;